import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../Redux/Actions/Action';

function SignIn() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const dispatch = useDispatch();
    const history = useHistory();
    const { authLoading, authError } = useSelector(state => state.Mainreducer);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await dispatch(login(email, password));
        if (result.success) {
            history.push('/dashboard');
            window.location.reload();
        }
    };

    return (
        <div
            style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'var(--body-color)',
                minHeight: '100vh',
                padding: '20px'
            }}
        >
            <div
                className="p-4 p-md-5 card border-0 shadow-sm"
                style={{
                    width: '100%',
                    maxWidth: '400px',
                    backgroundColor: 'var(--card-color)',
                    borderRadius: '16px'
                }}
            >
                <form onSubmit={handleSubmit}>
                    <div className="text-center mb-4">
                        <h2 className="fw-bold" style={{ color: 'var(--color-900)' }}>Welcome</h2>
                        <p className="text-muted mb-0">Enter your credentials to continue</p>
                    </div>

                    {authError && (
                        <div className="alert alert-danger py-2 text-center" role="alert">
                            <i className="bi bi-exclamation-triangle-fill me-2"></i>
                            {authError}
                        </div>
                    )}

                    <div className="mb-3">
                        <label className="form-label fw-semibold" style={{ color: 'var(--color-900)' }}>
                            Email Address
                        </label>
                        <div className="input-group">
                            <span
                                className="input-group-text border-0"
                                style={{ backgroundColor: 'var(--color-100)' }}
                            >
                                <i className="bi bi-envelope" style={{ color: 'var(--primary-color)' }}></i>
                            </span>
                            <input
                                type="email"
                                className="form-control form-control-lg border-0"
                                placeholder="name@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                style={{ backgroundColor: 'var(--color-100)' }}
                            />
                        </div>
                    </div>

                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <label className="form-label fw-semibold mb-0" style={{ color: 'var(--color-900)' }}>
                                Password
                            </label>
                            <Link
                                className="small"
                                to="/reset-password"
                                style={{ color: 'var(--primary-color)' }}
                            >
                                Forgot Password?
                            </Link>
                        </div>
                        <div className="input-group">
                            <span
                                className="input-group-text border-0"
                                style={{ backgroundColor: 'var(--color-100)' }}
                            >
                                <i className="bi bi-lock" style={{ color: 'var(--primary-color)' }}></i>
                            </span>
                            <input
                                type="password"
                                className="form-control form-control-lg border-0"
                                placeholder="********"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                style={{ backgroundColor: 'var(--color-100)' }}
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="btn btn-lg w-100 text-white fw-semibold"
                        disabled={authLoading}
                        style={{
                            background: 'linear-gradient(45deg, #45afaf, #0d6efd)',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '12px'
                        }}
                    >
                        {authLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                Signing in...
                            </>
                        ) : (
                            <>
                                <i className="bi bi-box-arrow-in-right me-2"></i>
                                Sign In
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default SignIn;
